import React, { useEffect } from "react";
import { Dropdown, Breadcrumb, Row, Col, Spinner } from 'react-bootstrap';
import { Link, useNavigate } from 'react-router-dom';
import Avatar from "../assets/img/User3.jpg";
import { useAuthStore } from "../store/useAuthStore";

const Header = ({ title }) => {
    const navigate = useNavigate();
    const { 
        logout, 
        isLoggedIn, 
        profile, 
        loading, 
        fetchProfile 
    } = useAuthStore();

    useEffect(() => {
        if (isLoggedIn && !profile) {
            fetchProfile().catch(console.error);
        }
    }, [isLoggedIn, profile, fetchProfile]);

    const handleLogout = () => {
        logout();
    };

    const getInitials = (name) => {
        if (!name) return '';
        return name.split(' ').map(n => n[0]).join('').toUpperCase();
    };

    return (
        <header className="header">
            <Row>
                <Col xs={6} className="align-self-center">
                    <div className="mainbreadcrumb d-none d-md-block">
                        <Breadcrumb>
                            <Breadcrumb.Item onClick={(e) => e.preventDefault()}>Pages</Breadcrumb.Item>
                            <Breadcrumb.Item active>{title}</Breadcrumb.Item>
                        </Breadcrumb>
                        {/* <h1>{title}</h1> */}
                    </div>
                </Col>
                <Col xs={6} className="text-end">
                    <div className='headerright' style={{ display: 'inline-flex', alignItems: 'center' }}>
                        <Dropdown>
                            <Dropdown.Toggle id="dropdown-basic" className="p-0" variant={null}>
                                {loading ? (
                                    <div className="profile-loader">
                                        <Spinner animation="border" size="sm" />
                                    </div>
                                ) : profile?.profilePic ? (
                                    <img 
                                        src={`${process.env.REACT_APP_MEDIA_URL}/${profile.profilePic}`} 
                                        alt={profile.fullName} 
                                        className="rounded-circle"
                                        style={{ width: '40px', height: '40px', objectFit: 'cover' }}
                                    />
                                ) : (
                                    <div 
                                        className="d-flex align-items-center justify-content-center rounded-circle bg-primary text-white"
                                        style={{ width: '40px', height: '40px' }}
                                    >
                                        {getInitials(profile?.fullName || 'U')}
                                    </div>
                                )}
                            </Dropdown.Toggle>
                            <Dropdown.Menu className="dropdown-menu-end">
                                {profile && (
                                    <div className="px-3 py-2">
                                        <div className="fw-bold">{profile.fullName || 'User'}</div>
                                        <small className="text-muted">{profile.email || ''}</small>
                                    </div>
                                )}
                                <Dropdown.Divider />
                                <Dropdown.Item as={Link} to="/profile-settings">Profile Settings</Dropdown.Item>
                                <Dropdown.Item onClick={handleLogout}>Logout</Dropdown.Item>

                            </Dropdown.Menu>
                        </Dropdown>
                    </div>
                </Col>
            </Row>
        </header>
    )
}

export default Header;